export default __webpack_public_path__ + "static/media/CNo.46-5.ada922c2.jpg";